import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "c-input-select__wrap" }
const _hoisted_2 = ["id", "name", "value", "error"]
const _hoisted_3 = ["value", "selected"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconArrowBottom = _resolveComponent("IconArrowBottom")!
  const _component_IconBase = _resolveComponent("IconBase")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("select", {
      id: _ctx.id,
      name: _ctx.name,
      value: _ctx.value,
      class: _normalizeClass(["c-input-select", [
        {
          'c-input-select--error': _ctx.error
        },
        _ctx.fontFamily ? `c-input-select--${_ctx.fontFamily}` : ''
      ]]),
      style: _normalizeStyle({ color: _ctx.color }),
      error: _ctx.error,
      onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updateValue && _ctx.updateValue(...args))),
      onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updateValue && _ctx.updateValue(...args))),
      onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('focus', $event))),
      onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('blur', $event)))
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, key) => {
        return (_openBlock(), _createElementBlock("option", {
          key: key,
          value: option.value,
          selected: _ctx.value === option.value
        }, _toDisplayString(option.label), 9, _hoisted_3))
      }), 128))
    ], 46, _hoisted_2),
    _createVNode(_component_IconBase, {
      class: _normalizeClass(["c-input-select__icon", {
        'c-input-select__icon--error': _ctx.error
      }]),
      "view-box": "0 0 24 24",
      width: "24",
      height: "24"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_IconArrowBottom)
      ]),
      _: 1
    }, 8, ["class"])
  ]))
}